import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Header from "../components/Header";

export default function EnterAmount() {
  const [amount, setAmount] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get data passed from previous page
  const { accAddress, cardId, share2 } = location.state || {};

  useEffect(() => {
    // Validate that we have the required card data
    if (!cardId || !share2) {
      alert("Missing card information. Please scan card or enter details.");
      navigate("/");
    }
  }, [cardId, share2, navigate]);

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setAmount(value);
  };

  const handleContinue = () => {
    if (!amount || parseFloat(amount) <= 0) {
      return alert("Please enter a valid amount");
    }

    navigate("/pin", {
      state: { 
        amount: parseFloat(amount), 
        cardId, 
        share2 
      },
    });
  };

  const truncateCardId = (id) => {
    if (!id) return "****";
    if (id.length <= 15) return id;
    return `${id.slice(0, 8)}...${id.slice(-4)}`;
  };

  return (
    <div className="p-6 h-screen flex flex-col items-center bg-gradient-to-b from-gray-900 to-gray-800 text-white px-6 pt-8">
      <Header />
      
      {/* Card Info Display */}
      <div className="w-full max-w-sm rounded-2xl p-4 mb-10 bg-gray-800/50 border border-gray-700">
        <p className="text-gray-400 text-sm">Payment From</p>
        <p className="text-lg font-semibold truncate mt-1">
          💳 {truncateCardId(cardId)}
        </p>
        {accAddress && (
          <p className="text-gray-500 text-xs mt-2">
            Merchant: {accAddress.slice(0, 6)}...{accAddress.slice(-4)}
          </p>
        )}
      </div>

      {/* Amount Input */}
      <h1 className="text-xl font-medium mb-6 opacity-80">Enter Amount</h1>
      <div className="relative w-full max-w-sm">
        <input
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          value={amount}
          onChange={handleChange}
          placeholder="0"
          autoFocus
          className="
            text-5xl font-bold text-white bg-gray-800 w-full py-4 pl-6 pr-6 text-center rounded-xl
            focus:outline-none focus:ring-2 focus:ring-blue-500
          "
        />
      </div>
      
      <p className="text-gray-400 text-sm mt-3">MUSD</p>

      {/* Continue Button */}
      <button
        onClick={handleContinue}
        disabled={!amount || parseFloat(amount) <= 0}
        className="mt-8 w-full max-w-sm bg-blue-600 py-4 rounded-full text-lg font-semibold shadow-lg hover:bg-blue-700 active:bg-blue-800 transition duration-150 disabled:bg-gray-600 disabled:cursor-not-allowed"
      >
        Continue
      </button>

      {/* Back Button */}
      <button
        onClick={() => navigate("/")}
        className="mt-4 text-gray-400 hover:text-white transition"
      >
        ← Cancel
      </button>
    </div>
  );
}
